module.exports = {
  lex: require('./lib/lexer'),
  parse: require('./lib/parser'),
  stringify: require('./lib/stringify')
};